export enum ManuType {
    OPEN_ACTIVITIES,
    CHANGE_PASSWORD,
    FAILED_IMAGES
}